var map = {
	"./Categories.png": 231,
	"./Coin.png": 188,
	"./Computer-Programming.png": 336,
	"./Connect.png": 641,
	"./Contact.png": 479,
	"./Current-Affairs.png": 509,
	"./Error.png": 681,
	"./Header-Challenges.png": 801,
	"./Header-Courses.png": 525,
	"./Header-Exams.png": 931,
	"./Header-Offline-Events.png": 82,
	"./Header-Online-Events.png": 742,
	"./Header-Problem-Solving.png": 653,
	"./Header-Sessions.png": 140,
	"./Header-Training.png": 817,
	"./Header-Your-Tasks.png": 967,
	"./Header.png": 788,
	"./How-It-Works.png": 918,
	"./How-Works.png": 396,
	"./Information-Technology.png": 426,
	"./Logo-On.png": 462,
	"./Logo-Transparent.png": 843,
	"./Logo.png": 286,
	"./Mathematics.png": 113,
	"./Point.png": 57,
	"./Science.png": 285,
	"./Shop.png": 399,
	"./Success.png": 282,
	"./Token.png": 44,
	"./Updates.png": 953,
	"./Verified.png": 791,
	"./Warning.png": 423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 664;